import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import UserHeader from '../../component/reusable/UserHeader';
import AllOrderTable from '../../component/ordersComps/AllOrderTable';
import Cards from '../../component/reusable/Cards';
import { exportOrderThunk, getAllOrderThunk, setOrderFromDate, setorderPage, setOrderSearch, setOrderStatus, setOrderToDate, setSelectedTab } from '../../redux/orderSlice';
import OrderFilter from '../../component/ordersComps/OrderFilter';
import OrderTabs from '../../component/ordersComps/OrderTabs';
import { exportDataExcel, fomateDate } from '../../utils/fomateDate';




function AllOrder() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [allStatus,setAllStatus] = useState('')
    const [limit, setLimit] = useState(25)
    const [sortBy, setSortyBy] = useState('createdAt');
    const [order, setOrder] = useState('asc')

    const handleChange = (event, newValue) => {
        dispatch(setSelectedTab(newValue))
        // setSelectedTab(newValue);
        setAllStatus('')
        dispatch(setorderPage(1))
        dispatch(setOrderSearch(''))
        dispatch(setOrderFromDate(''))
        dispatch(setOrderToDate(''))
    };
    const { orders, loading, refresh, page, search,  fromDate, toDate, exportLoading,selectedTab } = useSelector((state) => state.orders);
    const ordersData = orders?.data
    const totalPages = orders?.totalPages
    const totalItems = orders?.totalItems
    const itemsPerPage = orders?.limit

    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    const status = selectedTab === 0 ? allStatus : selectedTab === 1 ? 'PENDING' : selectedTab === 2 ? 'DELIVERED' : 'CANCELLED'

    useEffect(() => {
        dispatch(getAllOrderThunk(`?search=${search}&page=${page}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&sortBy=${sortBy}&order=${order}`));
    }, [page, search, status, limit, refresh, sortBy, order, fromDate,toDate]);

    

    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const exportOrder = async () => {
        const status = await dispatch(exportOrderThunk(`?limit=${100000}`))
        if (status?.payload?.success === true) {
            console.log("status", status?.payload?.data?.data);

            const exportOrderData = status?.payload?.data?.data
            const exportdata = exportOrderData?.map((item) => ({
                'id': item?._id || '-',
                'customer Name': item?.user?.fullName || '-',
                'Customer Email': item?.user?.email || '-',
                'productNumbers': item.products
                    .flatMap((product) =>
                        product.productDetails?.productOverview?.productNumber || []
                    )
                    .join(", "),
                'Total': item?.priceBreakup?.total || '-',
                'Status': item?.status || '-',
                'CreatedAt': fomateDate(item?.createdAt),
            }))
            console.log("expo", exportdata);

            exportDataExcel(exportdata, "orders")
        }
    }



    return (
        <>
            <UserHeader
                index="Order"
                root="Dashboard"
                onClickadd={() => navigate('/users/addVendor')}
                hideadd="hide"
                exportData={exportOrder}
                exportLoading={exportLoading}
            />

            <Cards />

            <Box>
                <OrderTabs handleChange={handleChange} selectedTab={selectedTab} />

                <OrderFilter setAllStatus={setAllStatus} selectedTabs={selectedTab} />
                <Box mt={2}>
                    {
                        loading ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>Loading...</div>
                            :
                            <>
                                {ordersData?.length > 0 ?
                                    <Typography>
                                        <AllOrderTable
                                            ordersData={ordersData}
                                            page={page}
                                            setPage={setorderPage}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            totalPages={totalPages}
                                            start={start}
                                            end={end}
                                            handleOpenMenu={handleOpenMenu}
                                        />
                                    </Typography>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        No Data found
                                    </div>
                                }
                            </>
                    }
                </Box>
            </Box >
        </>
    );
}

export default AllOrder;
